import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as api from 'services/oldApiService';
import { codeType, registryParams } from 'types/types';

const VerifyRegistrySharing = (props: any) => {
  const { registryId } = useParams<registryParams>();
  const { code } = useParams<codeType>();
  const [executed, setExecuted] = useState<boolean>(false);
  const navigate = useNavigate();

  const verify = async () => {
    setExecuted(true);

    const { status_code: statusCode, data } = await api.verifyRegistry(
      registryId,
      code
    );

    if (statusCode === api.status.SUCCESS) {

      navigate(`/registries/all-registries/${registryId}`)
    } else {
        navigate('/dashboard');
    }
  };

  const verifySharing = async () => {
    if (!executed) {
      verify();
    } else {
      return;
    }
  };
  verifySharing();
  return <div></div>;
};

export default VerifyRegistrySharing;
